import { createGlobalStyle } from 'styled-components';

const GlobalStyles = createGlobalStyle`
* {
    padding: 0;
    margin: 0;
    font-family: 'Varela Round', sans-serif;
    box-sizing: border-box;
    margin: 0;
};

html {
    height: 100%;
}

body {
    margin: 0 auto;
    height: 100%;
}

#root {
    height: 100%;
}

.ReactModal__Body--open {
    overflow-y: hidden;
}

.ReactModal__Content {
    max-width: 500px;
    width: 100% !important;

    
    @media screen and (min-width: 1000px) {
        max-width: 1000px;
        top: 0 !important;
        width: 80% !important;
    }
}

`;

export default GlobalStyles;
